import { JSONContent } from "@tiptap/core";
import dayjs from "dayjs";
import md5 from "blueimp-md5";
export const formatterTable = (row, cellValue = "") => {
  if (row === null || row === undefined || row === "") {
    return "-";
  }
  if (typeof row === "string" || typeof row === "number") {
    return row;
  }
  if (cellValue === "" || cellValue === null || cellValue === undefined) {
    return "-";
  } else {
    return cellValue;
  }
};
export const ssmlTags: { [key: string]: string } = {
  "say-as": "say-as",
  break: "break",
  phoneme: "phoneme",
  sub: "sub",
};

export const isSSMLTag = (nodeType?: string) => {
  return !!nodeType && !!ssmlTags[nodeType];
};

export function getSelectionText(
  json: JSONContent,
  from: number,
  to: number,
  includeTag = false
) {
  let selectionText = "";
  let currentPos = 1;
  console.log(json);

  const selectNodeText = (node: JSONContent) => {
    if (currentPos >= to) {
      return;
    }
    let inRange = currentPos >= from && currentPos < to;
    if (isSSMLTag(node.type)) {
      if (inRange) {
        selectionText += includeTag
          ? getNodeSSML(node)
          : `${node.attrs?.text || ""}`.trim();
      }
      currentPos += 1;
    } else if (node.type === "text" || node.text) {
      const text = node.text || "";
      for (let i = 0; i < text.length; i++) {
        inRange = currentPos >= from && currentPos < to;
        if (inRange) {
          selectionText += text[i];
        }
        currentPos++;
      }
    } else if (node.type === "hard_break" || node.type === "hardBreak") {
      if (inRange) {
        selectionText += includeTag ? "\n" : "";
      }
      currentPos += 1;
    } else if (node.type === "paragraph" && !node.content) {
      if (inRange) {
        selectionText += "\n";
      }
      currentPos += 2;
    } else {
      if (Array.isArray(node.content)) {
        node.content.forEach(selectNodeText);
        selectionText += "\n";
        currentPos += 2;
      }
    }
  };

  (json.content || []).forEach(selectNodeText);
  console.log(selectionText.trim(), "选中内容");
  return selectionText.trim();
}

export const getNodeSSML = (node: JSONContent) => {
  const attrs = node.attrs || {};
  const text = `${attrs.text || ""}`.trim();
  let ssml = "";
  if (!node.type) {
    return ssml;
  }

  const tagName = ssmlTags[node.type];
  if (tagName) {
    let attrStr = "";
    for (const key in attrs) {
      if (Object.prototype.hasOwnProperty.call(attrs, key)) {
        if (key.startsWith("_")) {
          continue;
        }
        const attr = `${attrs[key]}`.trim();
        if (attr) {
          attrStr += ` ${key}="${attr}"`;
        }
      }
    }
    if (text) {
      ssml = attrs._empty ? text : `<${tagName}${attrStr}>${text}</${tagName}>`;
    } else {
      ssml = `<${tagName}${attrStr}/>`;
    }
  }
  return ssml;
};

export const getUpdateTime = (unixTimestamp: number) => {
  if (unixTimestamp) {
    return dayjs.unix(unixTimestamp).format("YYYY-MM-DD HH:mm:ss");
  } else {
    return "-";
  }
};

// 判断目标时间是否在当前时间之后
export const isAfterCurrentTime = (targetTime) => {
  const result = dayjs.unix(targetTime).isAfter(dayjs()); // 默认毫秒
  return result;
};

// 将时间转化成时间戳
export const getTimeUnix = (dateStr) => {
  return dayjs(dateStr).unix();
};

export const base64ToBlob = function (
  base64: string,
  contentType = "",
  sliceSize = 512
) {
  const cleanedBase64 = base64.split(",")[1] || base64;
  const fixedBase64 = cleanedBase64.replace(/-/g, "+").replace(/_/g, "/");
  const padding = "=".repeat((4 - (fixedBase64.length % 4)) % 4);
  const validBase64 = fixedBase64 + padding;

  try {
    const byteCharacters = atob(validBase64);
    const byteArrays = [];

    // 将二进制数据分片处理，每片长度为sliceSize，创建Uint8Array数组。
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      // 创建Uint8Array数组，用于表示二进制数据的一个片段。
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    // 创建Blob对象，包含所有的二进制数据片段，并指定MIME类型。
    return new Blob(byteArrays, { type: contentType });
  } catch (e) {
    console.error("Failed to convert base64 to blob:", e);
    return null;
  }
};

export const authorizationDetection = async (platform, cookie) => {
  const platformUrls = {
    1: "https://creator.douyin.com/web/api/media/user/info/",
    3: "https://channels.weixin.qq.com/cgi-bin/mmfinderassistant-bin/auth/auth_data",
    4: "https://creator.xiaohongshu.com/api/galaxy/creator/home/personal_info",
  };
  const platformHeaders = {
    1: { cookie },
    3: { cookie },
    4: { cookie, referer: "https://creator.xiaohongshu.com/new/home" },
  };

  const url = platformUrls[platform];
  const headers = platformHeaders[platform];

  if (!url || !headers) return;

  try {
    return await window.electron.ipcRenderer.getAccountRequest({
      url,
      headers,
      method: platform === 3 ? "POST" : "GET",
    });
  } catch (error) {
    console.error(`Error fetching data for platform ${platform}:`, error);
    return error;
  }
};

export const SecureStringGenerator = (() => {
  // 获取浏览器指纹
  const getFingerprint = () => {
    const navigatorInfo = [
      navigator.userAgent,
      navigator.language,
      screen.width,
      screen.height,
      screen.colorDepth,
      navigator.platform,
      navigator.hardwareConcurrency, // CPU核心数
    ];
    return navigatorInfo.join("-"); // 合并信息
  };

  // 基于浏览器指纹生成加密字符串
  const generate = (length) => {
    const fingerprint = getFingerprint();
    let hash = 0;

    // 简单哈希算法（字符串转数值）
    for (let i = 0; i < fingerprint.length; i++) {
      const char = fingerprint.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash |= 0; // 保证为32位整数
    }

    // 将哈希值转换为字符串
    let result = "";
    while (result.length < length) {
      hash = (hash * 31) & 0xffffffff; // 更新哈希值
      const charCode = (Math.abs(hash) % 94) + 33; // 映射到可打印字符范围 [33, 126]
      result += String.fromCharCode(charCode);
    }

    return md5(result.slice(0, length)); // 返回指定长度的字符串
  };

  return { generate };
})();
export function formatSecondsToMMSS(seconds) {
  // 确保输入是数字
  const sec = parseInt(seconds, 10);

  // 处理无效输入
  if (isNaN(sec) || sec < 0) {
    return "00:00";
  }

  // 计算分钟和秒数
  const minutes = Math.floor(sec / 60);
  const remainingSeconds = sec % 60;

  // 格式化为两位数
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(remainingSeconds).padStart(2, "0");

  return `${formattedMinutes}:${formattedSeconds}`;
}

export const debounce = (
  func: (...args: any[]) => any,
  wait: number,
  context?: any,
  immediate = false
): ((...args: any[]) => any) => {
  context = context || null;
  let timeout: number | null;
  return (...args: any[]) => {
    const later = () => {
      timeout = null;
      if (!immediate) {
        func.call(context, ...args);
      }
    };
    const callNow = immediate && !timeout;
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = window.setTimeout(later, wait);
    if (callNow) {
      func.call(context, ...args);
    }
  };
};
